<template>
  <section class="other-tours">
    <h2 class="other-tours__heading">{{ title }}</h2>
    <div class="other-tours__list-wrapper">
      <div class="other-tours__list">
        <OtherToursItem
          v-for="link in links"
          :key="link?.slug"
          :class="{ 'view-all-elements': showFullList }"
          :link="link"
        />
      </div>
    </div>
    <UiButton
      v-if="showExpandBtn"
      data-test="listin-other-tours-btn-expand"
      text="Развернуть"
      :variant="UiButtonVariant.OUTLINE"
      :color-mode="UiButtonColorMode.NEUTRAL"
      :size="UiButtonSize.S"
      @clicked="expand"
    />
  </section>
</template>

<script lang="ts" setup>
  import { UiButton, UiButtonVariant, UiButtonColorMode, UiButtonSize } from '@experience/core-button-ui';
  import { ref, computed } from 'vue';

  import { type Link } from '@/shared/models';
  import OtherToursItem from '@/shared/ui/OtherTours/OtherToursItem.vue';
  import { useScreenSize } from '@/shared/utils/breakpoints';

  const { isTabletOnly, isMobile, isDesktopMedium } = useScreenSize();

  const props = defineProps<{
    links: Link[];
    title: string;
  }>();

  const showFullList = ref(false);

  const list = computed(() => {
    return props.links?.length ? props.links : [];
  });

  const showExpandBtn = computed(() => {
    let isViewButton = false;

    if (isMobile.value || isTabletOnly.value) {
      isViewButton = list.value?.length > 4;
    } else if (isDesktopMedium.value) {
      isViewButton = list.value?.length > 9;
    } else {
      isViewButton = list.value?.length > 8;
    }

    return isViewButton && !showFullList.value;
  });

  const expand = () => {
    showFullList.value = true;
  };
</script>

<style scoped lang="scss">
  @use '@experience/design-tokens/typography';
  @use '@experience/shared/dist/assets/adaptivity';

  .other-tours__heading {
    margin-top: var(--alias-space-40);
    margin-bottom: var(--alias-space-16);

    @include typography.base-700-700-semi;

    @include adaptivity.mobile {
      margin-top: var(--alias-space-32);
    }
  }

  .other-tours__list-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: var(--alias-space-16);
  }

  .other-tours__list {
    width: 100%;
    columns: 4;

    @include adaptivity.desktop-xs {
      columns: 3;
    }

    @include adaptivity.tablet {
      columns: 2;
    }

    @include adaptivity.mobile {
      display: flex;
      flex-direction: column;
    }
  }

  .view-all-elements:nth-child(n + 1) {
    display: block;
  }
</style>
